import React, { useContext, useRef, useState } from 'react';
import { Select } from 'antd';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAllPeriodicals, getAllPeriodicalsEntry } from '../../NecttosComp/APICaller/ApiServices';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import moment from 'moment';
import { Body, closeAnimation, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

export const PeriodicalsEntry = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const [state, setState] = useState({});
	const [showForm, setShowForm] = useState(false);
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data = [] } = useQuery(['getAllPeriodicals', state.bookType], getAllPeriodicals(collegeId, state.bookType));
	const { data: subData = [], refetch } = useQuery(['getAllPeriodicalsEntry', state.bookItem], getAllPeriodicalsEntry(collegeId, state.bookItem));

	const [isLoading, setIsLoading] = useState(false);

	const managePeriodicals = async () => {
		try {
			setIsLoading(true);

			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/action/postPeriodicalsEntry', {
				collegeId,
				bookId: state.bookItem,
				bookType: state.bookType,
				bookDetails: state.bookDetails,
				issue: state.issue,
				volume: state.volume,
				year: state.year,
				fromDate: state.fromDate,
				endDate: state.endDate,
				price: state.price,
				date: state.date,
				_id: state?._id,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setState({
					mode: 'add',
					bookDetails: '',
					bookType: '',
					bookItem: '',
					bookItemval: '',
					price: '',
					date: '',
					issue: '',
					fromDate: '',
					endDate: '',
					volume: '',
					year: '',
					_id: '',
				});

				refetch();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	const { Option } = Select;

	{
		state.combinedLabel && <h5 className='text-xl font-semibold text-center mt-4'>{state.combinedLabel}</h5>;
	}

	return (
		<Main width='100%' height='100%' title='Periodicals Managment'>
			<Header>
				<div className='flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 w-full'>
					<div className='flex flex-col sm:flex-row gap-4 w-full sm:w-auto'>
						<Input2
							type='drop'
							fieldName='Type of Periodicals'
							returnKey='bookType'
							state={state}
							setState={(newState) => {
								setState((prev) => ({
									...prev,
									bookType: newState.bookType,
									bookItem: '',
									bookItemval: '',
									combinedLabel: '',
								}));
							}}
							options={[
								{ label: 'Journals', value: 'Journals' },
								{ label: 'Magazines', value: 'Magazines' },
								{ label: 'Dailies', value: 'Dailies' },
							]}
							optionDisplay='label'
							optionKey='value'
							className='w-full sm:min-w-[300px] bg-white dark:text-slate-100'
						/>

						<Input2
							type='drop'
							fieldName='Select Item'
							returnKey='bookItem'
							didntShowKey
							state={state}
							setState={(newState) => {
								const selectedItem = data.find((d) => d._id === newState.bookItem);
								const nameOfBook = selectedItem?.nameOfBook || '';
								setState((prev) => ({
									...prev,
									bookItem: newState.bookItem,
									bookItemval: nameOfBook,
									combinedLabel: `${prev.bookType || ''} - ${nameOfBook}`,
								}));
							}}
							options={data}
							optionDisplay='nameOfBook'
							optionKey='_id'
							className='w-full sm:min-w-[350px] bg-white dark:text-slate-100'
						/>
					</div>

					<div className='flex flex-wrap sm:flex-nowrap items-center gap-3'>
						<Button
							type='update'
							onClick={() => {
								setState({
									bookDetails: '',
									bookType: '',
									bookItem: '',
									bookItemval: '',
									price: '',
									date: '',
									issue: '',
									fromDate: '',
									endDate: '',
									volume: '',
									year: '',
									_id: '',
								});
								setShowForm(true);
							}}>
							Add New
						</Button>

						<Button type='fetch' onClick={refetch}>
							Reload
						</Button>

						<Button type='print' tableRef={componentRef.current}>
							Print
						</Button>
							<Instruction keyId={'periodicalsEntry'}/>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable bg-white rounded-lg'>
					{state.bookItem ? (
						<div className='w-full max-h-[90vh] overflow-auto rounded-2x dark:bg-neutral-800 border border-gray-300 dark:border-gray-600 p-4'>
							<h5 className='text-[30px] text-center font-semibold   dark:text-slate-200'>{state.bookItemval?.slice(0, 5).replace(/[0-9]/g, '') + state.bookItemval?.slice(5) || 'Periodicals Management'}</h5>

							<Table width='100%' innerWidth={['4%', '5%', '13%', '10%', '6%', '20%', '14%', '14%', '10%', '4%']}>
								<Thead>
									<Tr>
										<Th position={0} textAlign='center'>
											Sn
										</Th>
										<Th position={1} textAlign='center'>
											Year
										</Th>
										<Th position={2}>Date of Received</Th>
										<Th position={3}>Issue</Th>
										<Th position={4}>Volume</Th>
										<Th position={5}>Details</Th>
										<Th position={6}>From Date</Th>
										<Th position={7}>End Date</Th>
										<Th position={8}>Price</Th>
										<Th position={9} className='print:hidden'></Th>
									</Tr>
								</Thead>
								<Tbody>
									{subData?.map((item, i) => (
										<Tr key={i} index={i} className='print:break-inside-avoid'>
											<Td position={0} index={i} textAlign='center'>
												{i + 1}
											</Td>
											<Td position={1} index={i} textAlign='center'>
												{item?.year}
											</Td>
											<Td position={2} index={i}>
												{moment(item?.date).format('DD MMM YYYY')}
											</Td>
											<Td position={3} index={i}>
												{item?.issue}
											</Td>
											<Td position={4} index={i}>
												{item?.volume}
											</Td>
											<Td position={5} index={i}>
												{item?.bookDetails}
											</Td>
											<Td position={6} index={i}>
												{item?.fromDate && moment(item?.fromDate).format('DD MMM YYYY')}
											</Td>
											<Td position={7} index={i}>
												{item?.endDate && moment(item?.endDate).format('DD MMM YYYY')}
											</Td>
											<Td position={8} index={i}>
												{item?.price}
											</Td>
											<Td position={9} index={i}>
												<div className='print:hidden'>
													<Button
														type='edit'
														onClick={() => {
															setShowForm(true);
															setState({
																mode: 'edit',
																_id: item?._id || '',
																bookDetails: item.bookDetails,
																bookType: item.bookType,
																bookItem: item.bookId,
																bookItemval: item?.nameOfBook || '',
																date: moment(item.date).format('YYYY-MM-DD'),
																price: item.price,
																issue: item.issue,
																volume: item.volume,
																fromDate: moment(item.fromDate).format('YYYY-MM-DD'),
																endDate: moment(item.endDate).format('YYYY-MM-DD'),
															});
														}}>
														Edit
													</Button>
												</div>
											</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
					) : (
						<div className='w-full overflow-x-auto print:overflow-visible max-h-[90vh] rounded-2xl bg-gray-100 dark:bg-neutral-800 border border-gray-300 dark:border-gray-600 print:bg-white print:text-black p-4'>
							<h5 className='text-2xl font-semibold text-center mb-4 dark:text-slate-200 print:text-black'>Periodicals Management</h5>

							<Table width='100%' innerWidth={['4%', '5%', '10%', '10%', '8%', '8%', '8%', '8%', '8%', '8%', '8%', '10%', '10%', '10%', '15%']}>
								<Thead>
									<Tr>
										<Th position={0}>Sn</Th>
										<Th position={1}>Year</Th>
										<Th position={2}>Title</Th>
										<Th position={3}>Periodicals</Th>
										<Th position={4}>Price</Th>
										<Th position={5}>Vendor</Th>
										<Th position={6}>V Mobile</Th>
										<Th position={7}>Type</Th>
										<Th position={8}>Subject</Th>
										<Th position={9}>Language</Th>
										<Th position={10}>Archives</Th>
										<Th position={11}>Postal Address</Th>
										<Th position={12}>DD Address</Th>
										<Th position={13}>ISSN</Th>
										<Th position={14}>Book Details</Th>
									</Tr>
								</Thead>
								<Tbody>
									{data?.map((item, i) => (
										<Tr key={i} index={i} className='print:break-inside-avoid'>
											<Td position={0} index={i}>
												{i + 1}
											</Td>
											<Td position={1} index={i}>
												{item?.year}
											</Td>
											<Td position={2} index={i}>
												{item?.nameOfBook}
											</Td>
											<Td position={3} index={i}>
												{item?.piriodicity}
											</Td>
											<Td position={4} index={i}>
												{item?.price}
											</Td>
											<Td position={5} index={i}>
												{item?.vendor}
											</Td>
											<Td position={6} index={i}>
												{item?.vendorMobile}
											</Td>
											<Td position={7} index={i}>
												{item?.bookType}
											</Td>
											<Td position={8} index={i}>
												{item?.subject}
											</Td>
											<Td position={9} index={i}>
												{item?.language}
											</Td>
											<Td position={10} index={i}>
												{item?.arcgives}
											</Td>
											<Td position={11} index={i}>
												{item?.postalAddress}
											</Td>
											<Td position={12} index={i}>
												{item?.ddAddress}
											</Td>
											<Td position={13} index={i}>
												{item?.issnNumber}
											</Td>
											<Td position={14} index={i}>
												{item?.bookDetails}
											</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
					)}
				</div>
			</Body>

			{showForm && (
				<div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm'>
					<Main width='40vw' height='80vh' title={state.alert ? state.alert : state.mode === 'edit' ? 'Edit Periodical Entry' : 'Add New Periodical'}>
						<Header>
							<div className='flex'></div>
							<div className='flex'>
								<Button
									type='close'
									onClick={() => {
										closeAnimation();
										setTimeout(() => setShowForm(false), 500);
									}}>
									Close
								</Button>
							</div>
						</Header>
						<Body>
							<div className='grid grid-cols-1 md:grid-cols-2 gap-4 px-4 items-start'>
								<Input2 type='number' fieldName='Year' returnKey='Year of Account' state={state} setState={setState} className='w-full' />

								<Input2
									type='drop'
									fieldName='Type of Periodicals'
									returnKey='bookType'
									state={state}
									setState={setState}
									options={[
										{ label: 'Journals', value: 'Journals' },
										{ label: 'Magazines', value: 'Magazines' },
										{ label: 'Dailies', value: 'Dailies' },
									]}
									optionDisplay='label'
									optionKey='value'
									className='w-full'
								/>

								<Input2
									type='drop'
									fieldName='Select Item'
									returnKey='bookItem'
									state={state}
									setState={(newState) => {
										const selectedItem = data.find((d) => d._id === newState.bookItem);
										setState((prev) => ({
											...prev,
											bookItem: newState.bookItem,
											bookItemval: selectedItem?.nameOfBook || '',
										}));
									}}
									options={data}
									didntShowKey
									optionDisplay='nameOfBook'
									optionKey='_id'
									className='w-full'
								/>

								<Input2 type='date' fieldName='Received Date' returnKey='date' state={state} setState={setState} className='w-full' />

								<Input2 type='text' fieldName='Volume Number' returnKey='volume' state={state} setState={setState} className='w-full' />

								<Input2 type='text' fieldName='Issue' returnKey='issue' state={state} setState={setState} className='w-full' />

								<div className='w-full'>
									<label className='text-gray-800 dark:text-slate-100 text-sm mb-1 block'>Other Details if any</label>
									<SearchableImput keyData='bookDetails' collection='bookStocks' stateData={state} setStateData={setState} />
								</div>

								<Input2 type='date' fieldName='From Date' returnKey='fromDate' state={state} setState={setState} className='w-full' />

								<Input2 type='date' fieldName='End Date' returnKey='endDate' state={state} setState={setState} className='w-full' />

								<Input2 type='number' fieldName='Price' returnKey='price' state={state} setState={setState} className='w-full' />

								<div className='flex justify-between col-span-2'>
									<Button
										type='close'
										onClick={() => {
											setShowForm(false);
											setState({
												...state,
												bookDetails: '',
												bookType: '',
												bookItem: '',
												price: '',
												date: '',
												issue: '',
												fromDate: '',
												endDate: '',
												volume: '',
												_id: '',
											});
										}}>
										Cancel
									</Button>
									<Button
										type='submit'
										onClick={() => {
											managePeriodicals();
										}}>
										Submit
									</Button>
								</div>
							</div>
						</Body>
					</Main>
				</div>
			)}
		</Main>
	);
};
